import styled from 'styled-components';

import { Breakpoint, Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { Image } from '../image/image.component';

export const Container: StyledComponent<'div'> = styled.div`
  display: flex;
  
  @media ${Breakpoint.Mobile} {
    flex-direction: column;
  }
`;

export const ImageContainer: StyledComponent<'div'> = styled.div`
  width: 50%;
  height: 600px;

  @media ${Breakpoint.Mobile} {
    width: 100%;
    height: 360px;
  }

  @media ${Breakpoint.SmallMobile} {
    height: 348px;
  }
`;

export const ImageElement: StyledComponent<typeof Image> = styled(Image)`
  object-fit: cover;
  width: 100%;
  height: 100%;
`;

export const TextContainer: StyledComponent<'div'> = styled.div`
  width: 50%;
  height: 600px;
  background-color: ${Color.Gray200};
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;

  @media ${Breakpoint.Mobile} {
    width: 100%;
    height: 360px;
    padding: 24px;
  }

  @media ${Breakpoint.SmallMobile} {
    height: 348px;
    padding: 20px;
  }
`;

export const Title: StyledComponent<'div'> = styled.div`
  font-weight: ${FontWeight.Medium};
  font-size: 40px;
  line-height: 44px;
  letter-spacing: 0.01em;
  color: ${Color.Black};

  @media ${Breakpoint.Mobile} {
    font-size: 30px;
    line-height: 38px;
  }
`;
